import DownloadIcon from "@mui/icons-material/Download";
import { Button, Tooltip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

export type DownloadButtonProps = {
  onClick: () => void;
  disabled?: boolean;
  tooltipText: string;
  buttonText?: string;
  testId?: string;
};

const DownloadButton = ({
  onClick,
  disabled = false,
  tooltipText,
  buttonText,
  testId = "download-button",
}: DownloadButtonProps) => {
  const theme = useTheme();
  const { t } = useTranslation(["common", "promotions"]);

  const displayText = buttonText || t("common:table.download.textV2");

  return (
    <Tooltip title={tooltipText} disableHoverListener={disabled}>
      <span data-testid={`${testId}-box`}>
        <Button
          data-testid={testId}
          disabled={disabled}
          onClick={onClick}
          variant="text"
          sx={{
            border: "none",
            color: theme.tokens.FuelColorJdGreen,
            boxShadow: "none",
            padding: theme.tokens.FuelSpacing2,
            margin: theme.tokens.FuelSpacing4,
          }}
        >
          <DownloadIcon
            sx={{
              fontSize: theme.tokens.FuelSpacing4,
              marginRight: theme.tokens.FuelSpacing1,
            }}
          />
          {displayText}
        </Button>
      </span>
    </Tooltip>
  );
};

export default DownloadButton;
